/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const { project } = feature;
    const MQTT_INTERFACE = 'current_interface';
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const MQTT_NAME = feature.getSettingValue('MQTT_NAME');
    const MQTT_PASSWORD = feature.getSettingValue('MQTT_PASSWORD');
    const MQTT_APP_CLIENT_ID = feature.getSettingValue('MQTT_APP_CLIENT_ID');
    const MQTT_SERVER_HOST = feature.getSettingValue('MQTT_SERVER_HOST');
    const MQTT_DESTINATION_PORT = feature.getSettingValue('MQTT_DESTINATION_PORT');
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    const TOPICS = feature.getSettingValue('TOPICS');


    //     if (CERTIFICATEFILE !== '') {
    //         blocks.push({
    //             location: 'GLOBAL_DEFINES',
    //             blockType: BlockType.CODE,
    //             template: `
    // #define MQTT_CER_FILE "${CERTIFICATEFILE.split('\n')[0]}"`,
    //         });
    //     }

    for (let i = 0; i < TOPICS.length; i++) {
        const topic = TOPICS[i];
        blocks = blocks.concat(topic.getCodeBlocks());
    }

    //     blocks.push({
    //         location: 'GLOBAL_CONSTS',
    //         blockType: BlockType.CODE,
    //         template: `
    // const MQTT_TLS = ${feature.getSettingValue('MQTT_TLS')}
    // `,
    //     });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
const current_interface = '';
        `,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.mqttHandler = new MQTTHandler(current_interface,${MQTT_SERVER_HOST},${MQTT_DESTINATION_PORT},${MQTT_NAME},${MQTT_PASSWORD},${MQTT_APP_CLIENT_ID},false)
this.mqttHandler.connect();
`,
    });


    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
class MQTTHandler {
    constructor(mqtt_interface, server, port, name, password, clientId, tls) {
        this.interface = mqtt_interface;

        this.server = server;

        this.port = port;

        this.name = name;

        this.password = password;

        this.clientId = clientId;

        this.tls = tls;

        this.client = null;

        this.handleConnect = this.handleConnect.bind(this);
    }

    connect() {
        console.log('Attempting to connect to MQTT broker via WebSocket...');
        this.client = mqtt.connect(\`ws://\${this.server}:\${this.port}\`, {
            username: this.name,
            clientId: this.clientId,
            password: this.password,
            keepalive: 30,
            connectTimeout: 30000,
        });
        this.client.on('connect', this.handleConnect);
        this.client.on('message', (topic, message) => {
            this.execute(topic, message.toString());
        });
        this.client.on('error', (error) => {
            console.log('MQTT client error:', error);
        });
        this.client.on('close', () => {
            console.log('MQTT client closed');
        });
    }

    publish(topic, message) {
        if (!this.client) {
            console.log('MQTT client not connected');
            return;
        }
        this.client.publish(topic, message);
    }

    subscribe(topic) {
        if (!this.client) {
            console.log('MQTT client not connected');
            return;
        }
        this.client.subscribe(topic);
    }

    handleConnect() {
        console.log('Connected to MQTT');
        callback_mqtt_connect_ok();
    }

    async execute(topic, message) {
        await callback_mqtt_notif(topic, message);
    }
}`,
    });


    return blocks;
};
